export const ID = '18c3be5a-8c3e-4f0c-9523-ba064e983004';

export const NAME = 'Contact Form';
